import React from 'react';

import IconMagnifier from '../icons/IconMagnifier';
import IconCross from '../icons/IconCross';

import './index.css';

const BaseSearchBar = (props) => {


  const onSubmit = (e) => {
    e.preventDefault();
    props.onSearch();
  }

  return (
    <form className={`${props.className} search-bar`} onSubmit={onSubmit}>
      <span
       onClick={props.value ? props.onClear : null}
       className="search-bar__icon"
      >
        {props.value
          ? <IconCross/>
          : <IconMagnifier/>
        }
      </span>
      <input
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        className="search-bar__input"
      />
    </form>
  );
}

export default BaseSearchBar;
